import * as Storage from '@/core/storage.js';
import Constants from '@/core/constants';

const isGuestUser = () => {
    const user = Storage.getItem(Constants.KEY_USER);

    if (user && user.usuario === 'invitado') {
        return 1;
    }

    return 0;
};

const getGuestUserToken = () => {
    return isGuestUser() === 1
        ? Storage.getItem(Constants.KEY_TOKEN_GUEST)
        : null;
};

const getUser = () => {
    return Storage.getItem(Constants.KEY_USER) || null;
};

const getUserId = () => {
    const user = getUser();
    return user ? user.id : null;
};

export {
    isGuestUser,
    getGuestUserToken,
    getUser,
    getUserId
};